(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mobile = window.matchMedia('(max-width: 759px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ADVANCE_MS = 4000;
    // After any touch, hover, key press or focus inside the carousel it
    // leaves the visitor alone for a while before it starts moving again.
    const IDLE_MS = 6000;

    document.querySelectorAll('[data-sadhoo-discover]').forEach((section) => {
      const rail = section.querySelector('[data-sadhoo-discover-rail]');
      const slides = Array.from(section.querySelectorAll('[data-sadhoo-discover-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-sadhoo-discover-dot]'));
      if (!rail || slides.length < 2) return;

      let activeIndex = 0;
      let frame = null;
      let pausedUntil = 0;
      let inView = true;

      // Distance from one slide to the next: slide width plus the rail's gap.
      function stepWidth() {
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      }

      function syncDots() {
        frame = null;
        const step = stepWidth();
        if (!(step > 0)) return;
        const index = Math.min(slides.length - 1, Math.max(0, Math.round(rail.scrollLeft / step)));
        if (index === activeIndex) return;
        activeIndex = index;
        dots.forEach((dot, position) => dot.classList.toggle('is-active', position === index));
      }

      rail.addEventListener('scroll', () => {
        if (frame === null) frame = requestAnimationFrame(syncDots);
      }, { passive: true });

      function pause() {
        pausedUntil = Date.now() + IDLE_MS;
      }
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin', 'mouseenter'].forEach((type) => {
        rail.addEventListener(type, pause, { passive: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          inView = entries[0].isIntersecting;
        }, { threshold: 0.35 }).observe(rail);
      }

      const timer = setInterval(() => {
        // The theme editor re-renders sections in place; stop for removed ones.
        if (!section.isConnected) {
          clearInterval(timer);
          return;
        }
        if (!mobile.matches || reduced.matches || document.hidden || !inView) return;
        if (Date.now() < pausedUntil) return;
        if (rail.scrollWidth <= rail.clientWidth + 4) return;
        const step = stepWidth();
        if (!(step > 0)) return;
        const next = (Math.round(rail.scrollLeft / step) + 1) % slides.length;
        rail.scrollTo({ left: next * step, behavior: 'smooth' });
      }, ADVANCE_MS);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const wrap = document.querySelector('[data-sadhoo-shop]');
    if (!wrap) return;

    // Each filter group (Gender/Notes/Mood) ships `open` in the markup so
    // it degrades sensibly with no JS. On mobile, where the whole filter
    // panel is already tucked behind its own "Filters" pill, collapse them
    // too — otherwise opening that pill dumps every option on screen at
    // once. Desktop keeps them open by default, untouched.
    if (window.innerWidth <= 759) {
      wrap.querySelectorAll('.sadhoo-collection__filter-group[open]').forEach((group) => {
        group.removeAttribute('open');
      });
    }

    const grid = wrap.querySelector('[data-sadhoo-shop-grid]');
    const cards = Array.from(wrap.querySelectorAll('[data-sadhoo-shop-card]'));
    const countEl = wrap.querySelector('[data-sadhoo-shop-count]');
    const emptyEl = wrap.querySelector('[data-sadhoo-shop-empty]');
    const sortSelect = wrap.querySelector('[data-sadhoo-shop-sort]');
    const clearButtons = wrap.querySelectorAll('[data-sadhoo-shop-clear]');
    // "Showing __VISIBLE__ of __TOTAL__ fragrances", with both numbers left
    // as placeholders by the markup so this script can refill them.
    const countTemplate = countEl ? countEl.dataset.template : '';
    const filterToggle = wrap.querySelector('[data-sadhoo-shop-filter-toggle]');
    const filterToggleLabel = wrap.querySelector('[data-sadhoo-shop-filter-toggle-label]');
    const filtersPanel = wrap.querySelector('[data-sadhoo-shop-filters]');

    function getChecked(name) {
      return Array.from(wrap.querySelectorAll('[data-sadhoo-filter="' + name + '"]:checked')).map((el) => el.value);
    }

    function activeFilterCount() {
      return wrap.querySelectorAll('[data-sadhoo-filter]:checked').length;
    }

    function paintFilterToggle() {
      if (!filterToggle || !filterToggleLabel) return;
      const open = filterToggle.getAttribute('aria-expanded') === 'true';
      const base = open ? filterToggle.dataset.closeLabel : filterToggle.dataset.openLabel;
      const count = activeFilterCount();
      filterToggleLabel.textContent = base + (count ? ' · ' + count : '');
    }

    function applyFilters() {
      const notes = getChecked('note');
      const moods = getChecked('mood');
      const genders = getChecked('gender');
      let visible = 0;

      cards.forEach((card) => {
        const cardNotes = (card.dataset.notes || '').split('||').filter(Boolean);
        const cardMood = card.dataset.mood || '';
        const cardGender = card.dataset.gender || '';
        const matchesNotes = notes.length === 0 || notes.some((n) => cardNotes.includes(n));
        const matchesMood = moods.length === 0 || moods.includes(cardMood);
        const matchesGender = genders.length === 0 || genders.includes(cardGender);
        const show = matchesNotes && matchesMood && matchesGender;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (countEl && countTemplate) {
        countEl.textContent = countTemplate.replace('__VISIBLE__', visible).replace('__TOTAL__', cards.length);
      }
      if (emptyEl) {
        emptyEl.hidden = visible !== 0;
      }
      if (grid) {
        grid.hidden = visible === 0;
      }
      paintFilterToggle();
    }

    function applySort() {
      if (!sortSelect || !grid) return;
      const value = sortSelect.value;
      const sorted = cards.slice().sort((a, b) => {
        if (value === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (value === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (value === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return 0;
      });
      if (value === 'featured') {
        cards.forEach((card) => grid.appendChild(card));
      } else {
        sorted.forEach((card) => grid.appendChild(card));
      }
    }

    // Some browsers restore checked/scroll state on a soft reload without
    // firing `change`, and the empty-state div starts `hidden` in markup —
    // run once up front so the two can never disagree with each other.
    wrap.querySelectorAll('[data-sadhoo-filter]').forEach((input) => { input.checked = false; });
    applyFilters();

    wrap.addEventListener('change', (event) => {
      if (event.target.matches('[data-sadhoo-filter]')) applyFilters();
      if (event.target === sortSelect) applySort();
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        wrap.querySelectorAll('[data-sadhoo-filter]').forEach((input) => { input.checked = false; });
        applyFilters();
      });
    });

    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', () => {
        const open = filterToggle.getAttribute('aria-expanded') !== 'true';
        filterToggle.setAttribute('aria-expanded', String(open));
        filtersPanel.classList.toggle('is-open', open);
        paintFilterToggle();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const DURATION_MS = 320;
    const EASING = 'cubic-bezier(.22, .61, .36, 1)';

    document.querySelectorAll('[data-sadhoo-faq-list]').forEach((list) => {
      const rows = Array.from(list.querySelectorAll('[data-sadhoo-faq-row]'));

      function stopAnimation(row) {
        if (row._sadhooAnimation) {
          row._sadhooAnimation.cancel();
          row._sadhooAnimation = null;
        }
      }

      function openRow(row) {
        stopAnimation(row);
        row.classList.remove('is-closing');
        row.open = true;
        if (reduced.matches) return;
        const panel = row.querySelector('[data-sadhoo-faq-panel]');
        const animation = panel.animate(
          [{ height: '0px', opacity: 0 }, { height: panel.scrollHeight + 'px', opacity: 1 }],
          { duration: DURATION_MS, easing: EASING }
        );
        row._sadhooAnimation = animation;
        animation.onfinish = () => {
          row._sadhooAnimation = null;
        };
      }

      function closeRow(row) {
        if (!row.open || row.classList.contains('is-closing')) return;
        stopAnimation(row);
        if (reduced.matches) {
          row.open = false;
          return;
        }
        const panel = row.querySelector('[data-sadhoo-faq-panel]');
        row.classList.add('is-closing');
        // `forwards` holds the shut state until the row is really closed, so
        // there is no one-frame flash of the full-height answer.
        const animation = panel.animate(
          [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: DURATION_MS, easing: EASING, fill: 'forwards' }
        );
        row._sadhooAnimation = animation;
        animation.onfinish = () => {
          row.open = false;
          row.classList.remove('is-closing');
          animation.cancel();
          row._sadhooAnimation = null;
        };
      }

      list.addEventListener('click', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !list.contains(summary)) return;
        event.preventDefault();
        const row = summary.parentElement;
        if (row.open && !row.classList.contains('is-closing')) {
          closeRow(row);
        } else {
          rows.forEach((other) => {
            if (other !== row) closeRow(other);
          });
          openRow(row);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The header is `position: fixed`, so it takes up no space in normal
  // document flow — any section starting at the top of the page renders
  // underneath it. Sections that need to keep their own content clear of
  // the header (rather than deliberately bleeding a background under it)
  // read this custom property instead of guessing a fixed clearance value,
  // so it stays correct as the header's real height changes across
  // breakpoints (e.g. the nav wrapping to two lines on narrow screens).
  //
  // The header also tightens its vertical padding once the page scrolls.
  // That is reported as its resting height, not the shrunken one, so
  // content positioned from this property never shifts while scrolling.
  function sadhooSyncHeaderHeight() {
    const header = document.querySelector('[data-sadhoo-header]');
    if (!header) return;
    const restPad = parseFloat(getComputedStyle(header).getPropertyValue('--sadhoo-header-pad-rest')) || 0;
    const setHeight = () => {
      const pad = parseFloat(getComputedStyle(header).paddingTop);
      const resting = header.offsetHeight + 2 * (restPad - (Number.isNaN(pad) ? restPad : pad));
      document.documentElement.style.setProperty('--sadhoo-header-height', `${resting}px`);
    };
    setHeight();
    new ResizeObserver(setHeight).observe(header);
  }
  sadhooSyncHeaderHeight();

  // Transparent at the very top of the page, solid and tighter once it has
  // scrolled a little (the same 20px threshold the design uses).
  function sadhooScrollHeader() {
    const header = document.querySelector('[data-sadhoo-header]');
    if (!header) return;
    let frame = null;
    const apply = () => {
      frame = null;
      const scrolled = window.scrollY > 20;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-top', !scrolled);
    };
    window.addEventListener('scroll', () => {
      if (frame === null) frame = requestAnimationFrame(apply);
    }, { passive: true });
    apply();
    requestAnimationFrame(() => header.classList.add('is-ready'));
  }
  sadhooScrollHeader();

  function sadhooMobileMenu() {
    const toggle = document.querySelector('[data-sadhoo-menu-toggle]');
    const menu = document.querySelector('[data-sadhoo-mobile-menu]');
    if (!toggle || !menu) return;

    const close = () => {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.dataset.openLabel);
    };
    const open = () => {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.dataset.closeLabel);
    };

    toggle.dataset.openLabel = toggle.getAttribute('aria-label');

    toggle.addEventListener('click', () => {
      if (menu.classList.contains('is-open')) close(); else open();
    });
    // Any link inside the menu (Fragrances, Wishlist, Bag, Account/Login)
    // should close it rather than leave it open behind the drawer/page it
    // just navigated to or opened.
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) close();
    });
    // The mobile-only nav collapses via a CSS media query at 759px; if a
    // resize crosses that breakpoint while the menu is open (e.g. rotating
    // a tablet, or a window drag), close it so it doesn't stay stuck open
    // behind the now-restored desktop nav.
    window.addEventListener('resize', () => {
      if (window.innerWidth > 759) close();
    });
  }
  sadhooMobileMenu();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notes-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-sadhoo-notes]');

    sections.forEach((section) => {
      const marquee = section.querySelector('[data-sadhoo-notes-marquee]');
      const preview = section.querySelector('[data-sadhoo-notes-preview]');
      if (!marquee || !preview) return;
      // The card is positioned against the outer section (tall, overflow
      // visible for this purpose) rather than the marquee rows wrapper
      // (short, and clipped for the scrolling pills) so it has real room
      // to travel and isn't clamped into a fixed spot.
      const stage = section;

      const img = preview.querySelector('[data-sadhoo-notes-preview-img]');
      const nameEl = preview.querySelector('[data-sadhoo-notes-preview-name]');
      const numEl = preview.querySelector('[data-sadhoo-notes-preview-num]');
      const totalEl = preview.querySelector('[data-sadhoo-notes-preview-total]');
      const pills = Array.from(marquee.querySelectorAll('[data-sadhoo-note-pill]')).filter((p) => p.dataset.noteImage);

      const uniqueProducts = [];
      const seen = new Set();
      pills.forEach((pill) => {
        if (!seen.has(pill.dataset.noteUrl)) {
          seen.add(pill.dataset.noteUrl);
          uniqueProducts.push({
            name: pill.dataset.noteName,
            image: pill.dataset.noteImage,
            url: pill.dataset.noteUrl
          });
        }
      });
      if (totalEl) totalEl.textContent = String(uniqueProducts.length).padStart(2, '0');
      if (!uniqueProducts.length) return;

      let currentIndex = -1;
      let swapTimer = null;
      let cycleTimer = null;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function showProduct(index) {
        if (index === currentIndex) return;
        currentIndex = index;
        const product = uniqueProducts[index];
        clearTimeout(swapTimer);
        img.style.opacity = '0';
        swapTimer = setTimeout(() => {
          img.src = product.image;
          img.alt = product.name;
          nameEl.textContent = product.name;
          if (numEl) numEl.textContent = String(index + 1).padStart(2, '0');
          img.style.opacity = '1';
        }, 160);
      }

      function startCycle() {
        if (reduced) return;
        clearInterval(cycleTimer);
        cycleTimer = setInterval(() => {
          showProduct((currentIndex + 1) % uniqueProducts.length);
        }, 2800);
      }

      function stopCycle() {
        clearInterval(cycleTimer);
      }

      function positionPreview(event) {
        const rect = stage.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        const w = preview.offsetWidth || 236;
        const h = preview.offsetHeight || 320;
        let left = x + 30 + w / 2;
        if (left + w / 2 > rect.width) left = x - 30 - w / 2;
        preview.style.left = Math.max(w / 2, Math.min(rect.width - w / 2, left)) + 'px';
        preview.style.top = Math.max(h / 2, Math.min(rect.height - h / 2, y)) + 'px';
      }

      stage.addEventListener('mouseenter', () => {
        preview.classList.add('is-visible');
        if (currentIndex === -1) showProduct(0);
        startCycle();
      });

      stage.addEventListener('mousemove', positionPreview);

      stage.addEventListener('mouseleave', () => {
        preview.classList.remove('is-visible');
        stopCycle();
      });

      pills.forEach((pill) => {
        const productIndex = uniqueProducts.findIndex((p) => p.url === pill.dataset.noteUrl);
        if (productIndex === -1) return;
        pill.addEventListener('mouseenter', () => {
          stopCycle();
          showProduct(productIndex);
        });
        pill.addEventListener('focus', () => {
          preview.classList.add('is-visible');
          stopCycle();
          showProduct(productIndex);
        });
        pill.addEventListener('mouseleave', startCycle);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function selectThumb(gallery, thumb) {
    const mainImg = gallery.querySelector('#sadhoo-pdp-main-image');
    if (mainImg && thumb.dataset.fullSrc) {
      // The main image renders with a `srcset` (responsive widths of the
      // *original* photo). Browsers that support srcset pick the displayed
      // image from those candidates and ignore a plain `.src` update —
      // so the swap silently no-ops unless srcset is cleared too.
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = thumb.dataset.fullSrc;
    }
    gallery.querySelectorAll('[data-sadhoo-thumb]').forEach((btn) => {
      btn.classList.toggle('is-active', btn === thumb);
      btn.setAttribute('aria-pressed', btn === thumb ? 'true' : 'false');
    });
  }

  function stepGallery(gallery, direction) {
    const thumbs = Array.from(gallery.querySelectorAll('[data-sadhoo-thumb]'));
    if (!thumbs.length) return;
    const activeIndex = thumbs.findIndex((btn) => btn.classList.contains('is-active'));
    const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
    selectThumb(gallery, thumbs[nextIndex]);
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-sadhoo-thumb]');
    if (thumb) {
      selectThumb(thumb.closest('[data-sadhoo-gallery]'), thumb);
      return;
    }

    const prevBtn = event.target.closest('[data-sadhoo-gallery-prev]');
    if (prevBtn) {
      stepGallery(prevBtn.closest('[data-sadhoo-gallery]'), -1);
      return;
    }

    const nextBtn = event.target.closest('[data-sadhoo-gallery-next]');
    if (nextBtn) {
      stepGallery(nextBtn.closest('[data-sadhoo-gallery]'), 1);
      return;
    }

    const qtyBtn = event.target.closest('[data-qty-decrease], [data-qty-increase]');
    if (qtyBtn) {
      const wrapper = qtyBtn.closest('[data-sadhoo-qty]');
      const valueEl = wrapper.querySelector('[data-qty-value]');
      const input = wrapper.parentElement.querySelector('[data-qty-input]');
      let value = parseInt(valueEl.textContent, 10) || 1;
      value = qtyBtn.hasAttribute('data-qty-increase') ? value + 1 : Math.max(1, value - 1);
      valueEl.textContent = value;
      if (input) input.value = value;
      return;
    }

    const testerOption = event.target.closest('[data-sadhoo-pdp-tester-option]');
    if (testerOption) {
      if (testerOption.disabled || testerOption.getAttribute('aria-pressed') === 'true') return;

      const wrap = testerOption.closest('[data-sadhoo-pdp-tester-options]');
      const companionInput = document.querySelector('[data-sadhoo-tester-companion-input]');

      // Picking a fragrance is purely a local choice — it's only actually
      // added to the cart together with the main product, when "Add to
      // bag" is submitted (see the companion-variant handling in
      // sadhoo-cart.liquid). No fetch, no drawer, no cart change here.
      wrap.querySelectorAll('[data-sadhoo-pdp-tester-option]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn === testerOption));
      });
      // The hint turns from "Pick a tester…" into a confirmation of the pick.
      const hint = document.querySelector('[data-sadhoo-pdp-tester-hint]');
      if (hint) {
        hint.textContent = hint.dataset.chosenText.replace('__NAME__', testerOption.dataset.variantName);
        hint.hidden = false;
      }
      if (companionInput) companionInput.value = testerOption.dataset.variantId;

      // Edge case: a tester from an earlier visit is already a real cart
      // line (reflected by the pre-selected chip on page load) and the
      // customer just switched to a different fragrance here. Quietly
      // retire that old line now — no drawer, no visible reaction — so
      // "Add to bag" doesn't leave two tester lines in the cart.
      const existingId = companionInput ? companionInput.dataset.existingTesterVariantId : null;
      if (existingId && existingId !== testerOption.dataset.variantId) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: existingId, quantity: 0 })
        });
        if (companionInput) companionInput.dataset.existingTesterVariantId = '';
      }
    }
  });

  // Free tester: a pending pick, staged on the PDP form's own companion
  // input and only actually added — together with the main product, in
  // one /cart/add.js call — when "Add to bag" is submitted. See the
  // companion-variant handling in sadhoo-cart.liquid.
  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[data-sadhoo-pdp-tester-toggle]');
    if (!toggle) return;
    const card = toggle.closest('.sadhoo-pdp__tester-card');
    const options = card.querySelector('[data-sadhoo-pdp-tester-options]');
    const hint = card.querySelector('[data-sadhoo-pdp-tester-hint]');
    const companionInput = document.querySelector('[data-sadhoo-tester-companion-input]');
    if (toggle.checked) {
      if (options) options.hidden = false;
      if (hint) {
        hint.textContent = hint.dataset.pickText;
        hint.hidden = false;
      }
    } else {
      if (options) options.hidden = true;
      if (hint) hint.hidden = true;
      if (options) {
        options.querySelectorAll('[data-sadhoo-pdp-tester-option]').forEach((btn) => {
          btn.setAttribute('aria-pressed', 'false');
        });
      }
      if (companionInput) companionInput.value = '';
    }
  });

  // Description: capped at two lines with a Read more / Show less toggle.
  // The toggle only appears when the text really overflows two lines — it
  // is measured by briefly lifting the clamp (same task, so nothing paints)
  // rather than trusting scrollHeight, which browsers disagree on for
  // line-clamped boxes.
  function initDescriptionToggles() {
    document.querySelectorAll('[data-sadhoo-desc]').forEach((wrap) => {
      const body = wrap.querySelector('[data-sadhoo-desc-body]');
      const toggle = wrap.querySelector('[data-sadhoo-desc-toggle]');
      if (!body || !toggle) return;

      function syncToggle() {
        if (!body.classList.contains('is-clamped')) {
          // Expanded: the toggle must stay so the text can be collapsed again.
          toggle.hidden = false;
          return;
        }
        const clampedHeight = body.clientHeight;
        body.classList.remove('is-clamped');
        const fullHeight = body.scrollHeight;
        body.classList.add('is-clamped');
        toggle.hidden = fullHeight <= clampedHeight + 1;
      }

      toggle.addEventListener('click', () => {
        const expand = body.classList.contains('is-clamped');
        body.classList.toggle('is-clamped', !expand);
        toggle.setAttribute('aria-expanded', String(expand));
        toggle.textContent = expand ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
        syncToggle();
      });

      syncToggle();
      window.addEventListener('resize', syncToggle);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncToggle);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionToggles);
  } else {
    initDescriptionToggles();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sadhoo-testimonials').forEach((section) => {
      const rail = section.querySelector('[data-rail]');
      const prev = section.querySelector('[data-rail-prev]');
      const next = section.querySelector('[data-rail-next]');
      if (!rail) return;

      function cardStep() {
        const card = rail.querySelector('.sadhoo-testimonials__card');
        const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '20');
        return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      }

      if (prev) {
        prev.addEventListener('click', () => {
          rail.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          rail.scrollBy({ left: cardStep(), behavior: 'smooth' });
        });
      }

      // Where the rail can rest: each card's left edge, but never past the
      // end of the scrollable range (the same stops native snapping uses).
      function snapStops() {
        const railLeft = rail.getBoundingClientRect().left;
        const max = rail.scrollWidth - rail.clientWidth;
        return Array.from(rail.querySelectorAll('.sadhoo-testimonials__card')).map((card) =>
          Math.min(max, card.getBoundingClientRect().left - railLeft + rail.scrollLeft)
        );
      }

      // Click-and-drag with a mouse (the "Drag to explore" hint). Touch and
      // trackpads already scroll the rail natively, so only a mouse pointer
      // is handled here. Snapping is paused while dragging and the rail
      // settles on the nearest stop when the button is released.
      let dragging = false;
      let startX = 0;
      let startLeft = 0;
      let moved = 0;

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = 0;
        startX = event.clientX;
        startLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      });

      rail.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const dx = event.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        rail.scrollLeft = startLeft - dx;
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        const here = rail.scrollLeft;
        const nearest = snapStops().reduce((best, stop) => (Math.abs(stop - here) < Math.abs(best - here) ? stop : best), here);
        rail.scrollTo({ left: nearest, behavior: 'smooth' });
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);

      // A drag is not a click, and the browser's own drag-and-drop of
      // selected text would take over the gesture.
      rail.addEventListener('click', (event) => {
        if (moved > 6) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      rail.addEventListener('dragstart', (event) => event.preventDefault());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
